import React from 'react'
import { Combobox, Field, Option } from '@fluentui/react-components'
import { UserAccount } from '../../../api/schemas/schema'
import { Control, Controller } from 'react-hook-form'
import { t } from '../../../i18n/i18n'
import { getFullName } from '../../../helpers/accountHelper'
import { AvatarName } from '../avatar/AvatarName'

type AccountPickerProps = {
   label: string
   name: any
   control: Control<any>
   accounts: UserAccount[]
   required?: boolean
   disabled?: boolean
}
export const ControlledAccountPicker = ({ label, name, control, required, disabled, accounts }: AccountPickerProps) => {
   return (
      <Controller
         name={name}
         control={control}
         rules={{
            validate: (value) => {
               if (required && !value) {
                  return t('AnAccountMustBeSelected')
               }
               return true
            },
         }}
         render={({ field: { value, onChange }, fieldState: { error }, formState: { disabled: formDisabled } }) => (
            <Field required={required ?? false} label={label} validationMessage={error ? t('AnAccountMustBeSelected') : undefined}>
               <Combobox
                  value={value ? getFullName(value) : ''}
                  selectedOptions={value ? [value.user.personalNumber] : []}
                  required={required ?? false}
                  freeform
                  disabled={(disabled || formDisabled) ?? false}
                  onOptionSelect={(e, data) => {
                     const chosenAccount = accounts.find((x) => x.user.personalNumber === data.optionValue)
                     if (chosenAccount) {
                        onChange(chosenAccount)
                     }
                  }}
               >
                  {accounts.map((account) => (
                     <Option key={account.user.personalNumber} value={account.user.personalNumber} text={getFullName(account)}>
                        <AvatarName name={getFullName(account)} />
                     </Option>
                  ))}
               </Combobox>
            </Field>
         )}
      />
   )
}
